export const queryKeys = {
  order: 'order',
  nw: {
    tips: 'nnworld-tips',
    user: 'nnworld-user',
    races: 'nnworld-races',
    equipment: 'nnworld-equipment',
  },
  product: {
    live: 'product-live',
  },
  stores: {
    all: 'stores-all',
  },
} as const;
